import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

interface DateRangeOptions {
  minDate?: Date;
  maxDate?: Date;
}

function clearTime(date: Date): Date {
  const clearedDate = new Date(date);
  clearedDate.setHours(0, 0, 0, 0);
  return clearedDate;
}

export function dateRangeValidator(
  options: DateRangeOptions = {}
): ValidatorFn {
  const defaultMinDate = new Date(2000, 0, 1);
  const defaultMaxDate = new Date();

  return (control: AbstractControl): ValidationErrors | null => {
    const dateArray = control.value as Date[];
    if (!dateArray || dateArray.length === 0) {
      return null;
    }

    const date = clearTime(dateArray[0]);
    const minDate = clearTime(options.minDate || defaultMinDate);
    const maxDate = clearTime(options.maxDate || defaultMaxDate);

    if (date < minDate || date > maxDate) {
      return { dateRange: true };
    }

    return null;
  };
}
